import {EResellerIds} from 'src/containers/User';
import {joi, mixed} from 'src/utils/validator';

import {TCompanyDetails} from './definitions';
import {getCompanyDetailsSchema, getResidentCountry} from './utils';

export const validateCompanyDetails = (details: TCompanyDetails, resellerId?: EResellerIds) => {
  const companySchema = getCompanyDetailsSchema(getResidentCountry(details?.country), {
    hasOgrn: resellerId === EResellerIds.OSK_ID,
    hasTaxNumber: !!details?.taxNumber,
    countryCode: details?.country,
  })(joi, mixed);

  return !companySchema.validate(details, {allowUnknown: true}).error;
};
